const ConfidenceFormatter = ({ children: value }) => {
  if (value === undefined || isNaN(value)) {
    return null;
  }

  return (Math.floor(value * 10000) / 100).toFixed(2) + '%';
};

export default ConfidenceFormatter;
